import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import authReducer, {
	AuthState,
	defaultState as defaultAuthState,
} from './auth/auth.reducer'

const reduxDevTools = (window as any).__REDUX_DEVTOOLS_EXTENSION__

export interface ApplicationState {
	auth: AuthState
}
export const defaultState: ApplicationState = {
	auth: defaultAuthState,
}

const reducers = combineReducers({
	auth: authReducer,
})

const enhances = compose(
	applyMiddleware(thunk),
	process.env.NODE_ENV !== 'production' && reduxDevTools
		? reduxDevTools()
		: (f: any) => f
) as any

export default createStore(reducers, defaultState, enhances)
